<script>
    import SubHeader from "../components/SubHeader.svelte";
    let subHeader = {
      bg_pc: '/images/sub_franchise.png',
      bg_mo: '/images/sub_franchise_m.png',
      title: '가맹 경쟁력',
      dsc: '커피멘토는 상권분석을 통한 매장 선정에서부터 인테리어,<br />매장 운영 지원까지 One-Stop Full-Service를 제공합니다.'
    }
</script>

<SubHeader { ...subHeader } />

<section class="franchise">
    <div class="franchise__full-service franchise-full-service">
        <h1 class="franchise-full-service__heading">One-Stop <span class="_newline" /> Full-Service</h1>

        <div class="franchise-full-service__contents-box">
            <div>
                <img class="franchise-full-service__content-symbol" src="/images/full_service01.png" alt=""/>
                <h5 class="franchise-full-service__content-title heading heading_level_5"> 상권분석</h5>
                <p class="franchise-full-service__content-description text">
                    상권 분석 전문가가 지역 상권을 분석하고<br/>
                    매장 위치 선정을 도와드립니다.<br/>
                    또 상권에 맞는 인테리어 제안과 운영교육을 진행합니다.
                </p>
            </div>
            <div>
                <img class="franchise-full-service__content-symbol" src="/images/full_service02.png" alt=""/>
                <h5 class="franchise-full-service__content-title heading heading_level_5"> 인테리어</h5>
                <p class="franchise-full-service__content-description text">
                    편안하면서도 고급스러운 느낌으로<br/>
                    시각적인 부분도 만족시켜 드립니다.
                </p>
            </div>

            <div>
                <img class="franchise-full-service__content-symbol" src="/images/full_service03.png" alt=""/>
                <h5 class="franchise-full-service__content-title heading heading_level_5"> 무인운영</h5>
                <p class="franchise-full-service__content-description text">
                    커피 멘토의 네트워크 시스템으로<br/>
                    진짜 무인 운영이 가능해<br/>
                    부업, 투잡으로, 또 육아, 학업과 병행이 가능합니다.
                </p>
            </div>
        </div>
    </div>

    <div class="franchise__process franchise-join-process">
      <h1 class="franchise-join-process__heading">가맹절차</h1>
      <div class="franchise-join-process__contents-box">
        <div class="franchise-join-process__content-arrow">
          <img class="franchise-join-process__content-img" src="/images/join_process01.svg" alt=""/>
          <h5 class="franchise-join-process__content-heading heading heading_level_5">1. 가맹상담</h5>
          <p class="franchise-join-process__content-description text">본사 가맹 상담 접수 후 창업 지원 상담</p>
        </div>

        <div class="franchise-join-process__content-arrow">
          <img class="franchise-join-process__content-img" src="/images/join_process02.svg" alt=""/>
          <h5 class="franchise-join-process__content-heading heading heading_level_5">2. 상권분석</h5>
          <p class="franchise-join-process__content-description text">전문 상권 분석을 통한 매장 위치 선정</p>
        </div>

        <div class="franchise-join-process__content-arrow">
          <img class="franchise-join-process__content-img" src="/images/join_process03.svg" alt=""/>
          <h5 class="franchise-join-process__content-heading heading heading_level_5">3. 가맹계약</h5>
          <p class="franchise-join-process__content-description text">가맹 계약 체결</p>
        </div>

        <div class="franchise-join-process__content-arrow">
          <img class="franchise-join-process__content-img" src="/images/join_process04.svg" alt=""/>
          <h5 class="franchise-join-process__content-heading heading heading_level_5">4. 인테리어 시공</h5>
          <p class="franchise-join-process__content-description text">매장 도면 설계 및 3D 모델링 후 시공 진행</p>
        </div>
        <div class="franchise-join-process__content-arrow">
          <img class="franchise-join-process__content-img" src="/images/join_process05.svg" alt=""/>
          <h5 class="franchise-join-process__content-heading heading heading_level_5">5. 영업준비</h5>
          <p class="franchise-join-process__content-description text">머신 입고 및 운영 교육, 오픈 리허설</p>
        </div>

        <div>
          <img class="franchise-join-process__content-img" src="/images/join_process06.svg" alt=""/>
          <h5 class="franchise-join-process__content-heading heading heading_level_5">6. 정식오픈</h5>
          <p class="franchise-join-process__content-description text">매장 정식 오픈 및 운영지원</p>
        </div>
      </div>
    </div>
</section>
